// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
  cartloadupt = true;
  //added by jumpstart
  var functionrunATC = true;
  masterpromorunThemeATC = true;
  console.log(masterpromorunNow,functionrunATC,masterpromorunThemeATC);
  var timer = setInterval(function() {
    console.log('loop interval');
    if(cartloadupt == false){
      if (masterpromorunThemeATC == functionrunATC && masterpromorunNow == false) {
        masterPromo(false);
      }
      functionrunATC = false;
      clearInterval(timer);
    }
  }, 100);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
  var container = evt.detail.container
  var currentVariant = evt.detail.variant.option1;

  var $currentSwiper = $(container).find('.swiper');

    if (currentVariant && $currentSwiper.length) {
      if ($currentSwiper.hasClass('below-mobile') || $currentSwiper.hasClass('above-mobile')) {
            if (swiperInstances.thumbnail) {
                swiperWrapperContent(swiperInstances.thumbnail, currentVariant, true);
            }
            if (swiperInstances.main) {
                swiperWrapperContent(swiperInstances.main, currentVariant, false);
            }
            if (swiperInstances.mobile) {
                swiperWrapperContent(swiperInstances.mobile, currentVariant, false);
            }
      } else {
            var currentSwiperIndex = $currentSwiper.data('swiper-index');

            if (swiperInstances.hasOwnProperty(currentSwiperIndex)) {
                var targetSwiper = swiperInstances[currentSwiperIndex];
                if (targetSwiper) {
                    swiperWrapperContent(targetSwiper, currentVariant, false);
                } else {
                    console.error('Swiper instance not found for index:', currentSwiperIndex);
                }
            } else {
                console.error('Invalid swiper index:', currentSwiperIndex);
            }
        }
    }
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function (evt) {
  console.log("Quickview loaded");
  var $loader = document.querySelector('.jsc-loader-overlay');
  $loader.style.display = 'block';
  initMySwiper();
  var link = document.querySelector('input[name=product-view-details-link]');
  var link_element = document.querySelector('.quick-view-view-product-details-link');
  if (link && link_element) {
    link_element.setAttribute('href', link.value);
  }

  var container = evt.detail.container
  var currentVariant = evt.detail.variantOption;
  var $currentSwiper = $(container).find('.swiper');
  var currentSwiperIndex = $currentSwiper.data('swiper-index');

  if (swiperInstances.hasOwnProperty(currentSwiperIndex)) {
    var targetSwiper = swiperInstances[currentSwiperIndex];
    if (targetSwiper) {
      swiperWrapperContent(targetSwiper, currentVariant, false);
    } else {
      console.error('Swiper instance not found for index:', currentSwiperIndex);
    }
  } else {
    console.error('Invalid swiper index:', currentSwiperIndex);
  }

  $loader.style.display = 'none';
});
